import {
  SET_LAYOUT,
  SET_VIEW,
  LOGOUT_USER,
  UPDATE_CAMSET,
  SET_ADMIN_NAV,
  SET_ALERT_MODAL,
} from '../actions/types';

const INITIAL_STATE = {
  layoutConfig: '1',      // number of camera grids in live view
  camset: 0,              // live view pagination
  view: 'live',           // options: live/playback/admin/utilities
  tz: 'America/Chicago',  // default timezone
  adminNav: 'users',      // selected admin nav page
  alertModal: [],         // if set, will show a modal containing the [0] as title and [1] as the message

  deviceBarOpen: false,         // to be deleted
  totalTreeExpanded: false,     // to be deleted
  treeRowExpanded: [],          // to be deleted
  customerTreeExpanded: false,  // to be deleted
};

// eslint-disable-next-line
export default ( state = INITIAL_STATE, action ) => {
  switch ( action.type ) {
    case SET_LAYOUT:
      let newLayout = state.layoutConfig;
      let newCamset = state.camset;
      if(action.payload !== state.layoutConfig){
        newLayout = action.payload;
        newCamset = 0
      }
      return {
        ...state,
        layoutConfig: newLayout,
        camset: newCamset
      }
    case UPDATE_CAMSET:
      return {
        ...state,
        camset: action.payload,
      }
    case SET_VIEW:
      return {
        ...state,
        view: action.payload
      }
    case SET_ADMIN_NAV:
      return {
        ...state,
        adminNav: action.payload,
      }
    case SET_ALERT_MODAL:
      return {
        ...state,
        alertModal: action.payload,
      }
    case LOGOUT_USER:
      return INITIAL_STATE
    default:
      return state;
  };
};